import { LoadingOutlined } from '@ant-design/icons';
import { Card, Col, Progress, Row, Spin } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSmoothScroll } from '../../../../../../../shared/hooks/useSmoothScroll';
import { RootState } from '../../../../../../../store';
import { getDateWithTextMonth } from '../../../../../../../utils/dateTimeUtils';
import { ReactComponent as TickIcon} from '../../../../../../../assets/images/svg/Card_Selected_icon.svg';
import { nameFormat } from '../../../../../../../utils/utility';
const BeneficiaryCard = ({ beneficiary, isSelected, index, loading, isBeneficiaryPopUpRequired, isConfirmed,
  disabled }: any): ReactElement => {
  useSmoothScroll('scroll-benef');
  const {
    memberName, memberId,
    policyStartDate, policyEndDate, policyHolderName,
    status, policyNo, percentageNameMatch, productName, memberPhoto,
  } = beneficiary;
  const {
     payerList: { payer: {shortName }, formControlConfig },
  } = useSelector((state: RootState): RootState => state);
  const [isShowFields, setIsShowFields] = useState(false);
  const payerConfigValues = Object.values(formControlConfig);
  const  productNameTobeShown = payerConfigValues?.some((config: any): any => Boolean(config?.showProductName));
  const getDate = (date: any): string => {
    const dateFormatted = getDateWithTextMonth(date);
    return dateFormatted === 'Invalid date' ? '-' : dateFormatted;
  };
  const getMemberImage = (memberPhoto || require('../../../../../../../assets/images/svg/Member_Account_icon.svg'));
  const getColor = (): any => {
    return percentageNameMatch >= 90 ? '#2AE1AA' : percentageNameMatch >= 60 ? '#F2BA29' : '#E15554';
  };
  useEffect((): void => {
    const isPresent = payerConfigValues?.filter(({ type }: any): any => type === 'bajaj');
    isPresent?.length > 0 ? setIsShowFields(false) : setIsShowFields(true);
  }, []);
  return (
    <Card data-testid="benefCard"
      className={`scroll-benef panel-styles benef-cards
      ${(isConfirmed) && 'benef-search-card'} ${disabled ? 'disabled-cards' : '' } card-selected mb-md`} hoverable={true}>
         <Col className="selected-Svg-Icon">
          {isConfirmed && <TickIcon/>}
          </Col>
        <Row className="beneficiary-card">
        <Col md={3} className="selectedicon">
        <img
          src={getMemberImage}
          alt="Member-Image"
          className="benef-member-image"
        />
        </Col>
          <Col md={18} style={{marginLeft: '8px'}}>
            <Row className="m-b-5">
              <Col md={8} className="text-elipsis label-title fsize_sm beneficiary-title">Patient Name   </Col><Col className={`${isConfirmed && 'cardSelected_memberName'} beneficiary-values`} style={{fontWeight: 'bold'}} md={16}>
             {nameFormat(memberName) || '-'}</Col>
            </Row>
            <Row className="m-b-5">
              <Col md={8} className="label-title fsize_sm beneficiary-title">Member ID  </Col>
              <Col md={16} className="beneficiary-values">{memberId || '-'}</Col>
            </Row>
            {isShowFields && <Row className="m-b-5">
              <Col md={8} className="label-title fsize_sm beneficiary-title">Policy Holder  </Col><Col md={16} className="beneficiary-values">
                {policyHolderName || '-'}</Col>
            </Row>}
            {isShowFields && <Row className="m-b-5">
              <Col md={8} className="label-title fsize_sm beneficiary-title">Policy Date </Col>
              {policyStartDate && policyEndDate ? (<Col md={16} className={'beneficiary-values'}>
                {getDate(policyStartDate) || '-'} {policyStartDate ? 'to' : ''} {getDate(policyEndDate) || '-'}
              </Col>) : '-'
              }
            </Row>}
            {['VIDAL', 'Bajaj', 'TATA AIG'].includes(shortName) && (
              <Row className="m-b-5">
                <Col md={8} className="text-elipsis label-title fsize_sm beneficiary-title">
                  Policy Number:
                </Col>
                <Col md={16} className={'beneficiary-values'}>{policyNo || '-'}</Col>
              </Row>
            )}
          {productNameTobeShown && (
            <Row className="m-b-5">
              <Col md={8} className="beneficiary-title">
                Product Name
              </Col>
              <Col md={16} className="beneficiary-values">{productName || '-'}</Col>
            </Row>
          )}
            {status &&
              <Row className="m-b-5">
                <Col md={8} className="label-title fsize_sm beneficiary-title">Status: </Col><Col md={16} className={'beneficiary-values'}>
                  {status || '-'}</Col>
              </Row>
            }
          </Col>
          {isBeneficiaryPopUpRequired &&
          <Col className="benef-doct-img" md={2}>
          <Progress type="circle" percent={percentageNameMatch > 0 ?
          percentageNameMatch : 100} strokeColor={getColor()} strokeWidth={15} width={40}
          format={(): any => `${percentageNameMatch}%`}/>
          </Col>
          }
        </Row>

        <Row justify="end">
          {
            isSelected && loading &&
            <Spin indicator={<LoadingOutlined style={{ fontSize: 18, marginTop: '-20px' }} spin={true} />} />
          }
        </Row>
    </Card>
  );
};

export default BeneficiaryCard;
